import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getWorkSpaces: () => ({
        type: actionTypes.GET_WORK_SPACES,
        payload: {
            promise: () => api.getWorkSpaces()
        }
    })
};
